import { ViewHeaderDescription } from './view-header-description'

export class SitemapReferenceItem {
  public id: string
  public idml: string
  public description: string
  public tDescription: string
  public associatedSiteMap: string
  public msName: string
  public viewHeaderDescription?: ViewHeaderDescription
  public entries: SitemapEntry[]

  constructor(model: SitemapReferenceItem) {
    this.id = model.id
    this.idml = model.idml
    this.description = model.description
    this.viewHeaderDescription = model.viewHeaderDescription
    this.entries = model.entries || []
    this.associatedSiteMap = model.associatedSiteMap
    this.tDescription = model.tDescription
    this.msName = model.msName
  }
}

export interface SitemapEntry {
  entity: string
  viewName: string
  isVisible: string
}
